import styled, { css } from "styled-components";
import { ADMIN_LK } from "@constants";

export const RootContainer = styled.div`
  height: calc(100vh - 70px);
  overflow: hidden;
  position: relative;
`;

export const EmptyText = styled.div`
  height: ${props => `calc(100vh - 235px - ${props.optHeight}px)`};
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  color: #808080;
`;

export const Container = styled.div.attrs({
  id: "scrollableDiv",
})`
  width: calc(100% - 32px);
  height: ${props => `calc(100vh - 235px - ${props.optHeight}px)`};
  padding: 80px 16px 12px 16px;
  overflow: auto;
  display: flex;
  flex-direction: column-reverse;
`;

export const TimeContainer = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const MessageText = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

a {
    color: #1677ff !important;

    :active {
      color: #1677ff !important;
    }
  }
`;

export const DateText = styled.div`
  margin-bottom: 6px;
  margin-top: 16px;
  font-size: 12px;
  font-weight: normal;
  color: #FFB829;
  text-align: center;
`;

export const SpinWrapper = styled.div`
  padding: 14px;
  text-align: center;
`;

const styles = css`
  height: ${props => `calc(100vh - 235px - ${props.optHeight}px)`};
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const InitialMessage = styled.div`
  ${(props) => props.size === "large" && styles}

  >div {
    padding: 12px;
    border-radius: 12px 12px 12px 0px;
    background-color: #161719;
    max-width: 250px;
    white-space: pre-wrap;
    word-break: break-word;
    width: fit-content;
    text-align: left;
    align-self: flex-start;

    @media screen and (max-width: 480px) {
      width: fit-content;
      max-width: 60vw !important;
    }
  }

  ${MessageText} {
    color: #101415;
    line-height: 1.5;
  }
`;

export const NameText = styled.span`
  color: #FFB829;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const TimeText = styled.span`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;


export const MessageItem = styled.div`
  margin-bottom: 16px;
  padding: 12px;
  border-radius: 12px;
  background-color: ${props => props.sender === ADMIN_LK ? '#161719' : '#CC9321'};
  max-width: 250px;
  white-space: pre-wrap;
  word-break: break-word;
  width: fit-content;
  text-align: ${props => props.sender === ADMIN_LK ? 'left' : 'right'};
  align-self: ${props => props.sender === ADMIN_LK ? 'flex-start' : 'flex-end'};

  .anticon {
    color: #E1A59C;
  }

  @media screen and (max-width: 480px) {
    width: fit-content;
    max-width: 60vw !important;
  }

    ${MessageText} {
      color: #F9F9F9;
    }

    ${TimeText} {
      color: ${props => props.sender === ADMIN_LK ? '#686B6E' : '#664A10'};
    }
`;
